import { EasmBulkChangeInvestigationPropertyDataProvider } from './EasmBulkChangeInvestigationPropertyDataProvider';
import { translateFn } from '../../../utils/translator.helper';
import { FindingClassType } from '../../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { getErrorMessage } from '../../utils';
import { AssetAction } from '../../assetsInventoryGrid/types';

export class EasmBulkChangeScanActionDataProvider extends EasmBulkChangeInvestigationPropertyDataProvider {
  public async changeBulkProperty(
    findingIds: string[],
    value: any,
    updateRelatedArtifacts: boolean,
    note: string
  ): Promise<any> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMFindings',
      method: 'changeBulkScanStatus',
      payload: {
        ids: findingIds,
        value,
        updateRelatedArtifacts,
        note,
      },
    });
  }

  public getTitle(): string {
    return translateFn('Change scan action?');
  }

  public getDescription(findingsClassType: FindingClassType, preSelectedValueLabel: string | null): string {
    // the change scan action is only for assets
    if (FindingClassType.ASSET === findingsClassType) {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The scan action of the selected assets will change to <b>{scanAction}</b>.',
          { scanAction: preSelectedValueLabel }
        )
        : translateFn('Select a scan action for this asset.');
    }

    throw new Error('The change scan action is only for assets.');
  }

  public getOptionsLabel(): string {
    return translateFn('Asset status');
  }

  public getOptionsPlaceholder(): string {
    return translateFn('Select asset status');
  }

  public getRequiredOptionErrorMessage(): string {
    return translateFn('Please select an asset status.');
  }

  public getApplyToArtifactsOptionLabel(): string {
    return translateFn('Apply the note to asset artifacts as well');
  }

  public getSuccessToastMessage(response: any): string {
    const count = response.count;

    if (response.actionType === AssetAction.INCLUDE) {
      return translateFn('Successfully included {count} assets.', { count });
    } else {
      return translateFn('Successfully excluded {count} assets.', { count });
    }
  }

  public getFailureToastMessage(error: any, value: any): string {
    return getErrorMessage(
      error?.err?.code,
      value === AssetAction.INCLUDE
        ? translateFn('Failed to include assets.')
        : translateFn('Failed to exclude assets.')
    );
  }

  // this method is not used in this class, but it is required by the base class
  protected getApiInvestigationProperty(): string {
    throw new Error('Method not implemented.');
  }
}
